import {createReducer} from '@reduxjs/toolkit';

import {
  clearMapPin,
  fitExtent,
  pinMap,
  setBaseLayer,
  setDrawTool,
  setMeasureMode,
  setOverlayOn,
  setUserOverlayUrl,
} from '../actions/map.js';

import {BASE_LAYERS} from '@apps-common/ui-maps/constants';
import {DEFAULT_OVERLAYS} from '@app/constants/mapLayers';

export const initialMapView = {
  /**
   * A hint to change extent to the map.
   * @type {Array<number>}
   */
  fitExtent: [],
};

export const initialState = {
  ...initialMapView,
  /**
   * The coordinate of a map pin
   * @type {Array<number>}
   */
  mapPin: null,

  drawTool: {
    name: '',
    layer: '',
    target: '',
  },

  /**
   * Whether to show an overlay layer.
   * @type {Boolean}
   */
  overlays: DEFAULT_OVERLAYS,

  baseLayer: BASE_LAYERS.SATELLITE,

  userOverlayUrl: '',

  measuring: false,
};

export default createReducer(initialState, builder => {
  builder.addCase(pinMap, (state, {payload}) => {
    state.mapPin = payload.coordinate;
  });

  builder.addCase(clearMapPin, state => {
    state.mapPin = initialState.mapPin;
  });

  builder.addCase(fitExtent, (state, {payload}) => {
    state.fitExtent = payload;
  });

  builder.addCase(setDrawTool, (state, {payload}) => {
    state.drawTool = payload;
  });

  builder.addCase(setBaseLayer, (state, {payload}) => {
    state.baseLayer = payload;
  });

  builder.addCase(setOverlayOn, (state, {payload}) => {
    state.overlays[payload.name] = payload.on;
  });

  builder.addCase(setUserOverlayUrl, (state, {payload}) => {
    state.userOverlayUrl = payload;
  });

  builder.addCase(setMeasureMode, (state, {payload}) => {
    state.measuring = !!payload;
  });
});
